import { FormattedMessage } from 'react-intl';
import { Outlet, generatePath } from 'react-router';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  ANY_SPORT_SCOUTING_CENTER_WATCHLISTS,
  ANY_SPORT_SCOUTING_CENTER_WATCHLISTS_ID,
  FOOTBALL_SCOUTING_CENTER_MATCHES,
  FOOTBALL_SCOUTING_CENTER_MATCHES_DAY,
  FOOTBALL_SCOUTING_CENTER_MATCHES_DAY_GAMEID,
  FOOTBALL_SCOUTING_CENTER_MATCHES_DAY_GAMEID_LINEUPS,
  FOOTBALL_SCOUTING_CENTER_MATCHES_DAY_GAMEID_PLAYERS,
  FOOTBALL_SCOUTING_CENTER_STATS,
  FOOTBALL_SCOUTING_CENTER_STATS_LEADERBOARDGROUP,
  FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG,
} from '@sorare/core/src/constants/__generated__/routes';
import {
  glossary,
  navLabels,
  scoutingCenter,
} from '@sorare/core/src/lib/glossary';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const Wrapper = styled(Vertical)`
  min-height: calc(100vh - var(--current-stack-height));
`;

enum ScoutingCenterTabs {
  MATCHES = 'matches',
  PLAYERS = 'players',
  WATCHLISTS = 'watchlists',
}

const TABS = [
  {
    tab: ScoutingCenterTabs.PLAYERS,
    label: navLabels.stats,
    to: generatePath(FOOTBALL_SCOUTING_CENTER_STATS),
    matches: [
      FOOTBALL_SCOUTING_CENTER_STATS,
      FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG,
      FOOTBALL_SCOUTING_CENTER_STATS_LEADERBOARDGROUP,
    ],
  },
  {
    tab: ScoutingCenterTabs.MATCHES,
    label: glossary.matches,
    to: generatePath(FOOTBALL_SCOUTING_CENTER_MATCHES),
    matches: [
      FOOTBALL_SCOUTING_CENTER_MATCHES,
      FOOTBALL_SCOUTING_CENTER_MATCHES_DAY,
      FOOTBALL_SCOUTING_CENTER_MATCHES_DAY_GAMEID,
      FOOTBALL_SCOUTING_CENTER_MATCHES_DAY_GAMEID_LINEUPS,
      FOOTBALL_SCOUTING_CENTER_MATCHES_DAY_GAMEID_PLAYERS,
    ],
  },
  {
    tab: ScoutingCenterTabs.WATCHLISTS,
    label: scoutingCenter.watchlists,
    to: generateSportPath(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS, {
      sport: Sport.FOOTBALL,
    }),
    matches: [
      ANY_SPORT_SCOUTING_CENTER_WATCHLISTS,
      ANY_SPORT_SCOUTING_CENTER_WATCHLISTS_ID,
    ],
  },
];
const ScoutingCenterLayout = () => {
  return (
    <ContentWithStickyHeader
      header={
        <TabBar variant="flat" fullWidth ignoreQueryParams>
          {TABS.map(({ to, tab, label, matches }) => (
            <Tab key={tab} to={to} matches={matches}>
              <FormattedMessage {...label} />
            </Tab>
          ))}
        </TabBar>
      }
    >
      <Wrapper>
        <Outlet />
      </Wrapper>
    </ContentWithStickyHeader>
  );
};

export default ScoutingCenterLayout;
